export default "__VITE_ASSET__7QJ7KZ9u__"